import { LicenseInfo } from '@mui/x-license';
export function initRubiksLicense() {
    LicenseInfo.setLicenseKey('24dbe0ae7b218da2430e4e50c31eeb35Tz0xMTQ0MjgsRT0xNzgxMzk1MTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=');
}
